import { render, staticRenderFns } from "./EditableUserField.vue?vue&type=template&id=31e8f4cf&scoped=true"
import script from "./EditableUserField.vue?vue&type=script&lang=js"
export * from "./EditableUserField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e8f4cf",
  null
  
)

export default component.exports